export default __webpack_public_path__ + "static/media/nav.3bd01347.png";